import { useEffect } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

interface GuidedTourProps {
    storageKey: string;
    steps: {
        id: string;
        title: string;
        description: string;
    }[];
}

const GuidedTour = ({ storageKey, steps }: GuidedTourProps) => {
    useEffect(() => {
        if (localStorage.getItem(storageKey)) {
            return;
        }

        const tour = driver({
            showProgress: true,
            doneBtnText: 'Got it',

            steps: steps.map(step => ({
                element: `#${step.id}`,
                popover: {
                    title: step.title,
                    description: step.description,
                },
            })),

            onDestroyed: () => {
                localStorage.setItem(storageKey, 'true');
            },
        });

        setTimeout(() => tour.drive(), 300);
    }, [ steps, storageKey ]);

    return null;
};

export default GuidedTour;
